// 1: small text
// 2: mid text
// 3: big text
export const columnsTitles = [
  { id: 1, title: 'Name', flexSize: 1 },
  { id: 2, title: 'Age', flexSize: 1 },
  { id: 3, title: 'Ethnicity', flexSize: 3 },
  { id: 4, title: 'Gender', flexSize: 1 },
];
